module.exports = __webpack_public_path__ + "img/under_construction.png";